import Button from '@space-lib/components/button'
import useTranslation from '@space-lib/hooks/useTranslation'
import defaultMember from '@space-shell/assets/images/default-banned-member.svg'
import Avatar from '@space-shell/common/components/avatar'
import type { UserBlockedFollowers } from '@space-shell/common/services/communities'

export type CardMemberProps = {
  user: UserBlockedFollowers
  onClick: (user: UserBlockedFollowers) => void
}

const CardMember = ({ user, onClick }: CardMemberProps) => {
  const { name, userName, email, imagePath } = user

  const { t } = useTranslation()

  return (
    <div className='_d-flex _justify-content-between align-items-center _mb-0 _px-4 _py-4 _border-gray-200 _w-full _border'>
      <div className='_d-flex _justify-content-start _align-items-center _w-full '>
        <div className='_mr-4'>
          <Avatar className='_bg-gray-300' size='md' urlAvatar={imagePath || defaultMember} />
        </div>

        <div className='_d-flex _flex-column'>
          <h2 className='_text-2 _text-gray-900 _mb-0'> {name || userName} </h2>

          {email ? (
            <small className='_text-1 _text-gray-900' data-test='card-member-user-email'>
              {email}
            </small>
          ) : null}
        </div>
      </div>

      <Button variation='default' onClick={() => onClick(user)}>
        {t('modal.ban_list.button_unban')}
      </Button>
    </div>
  )
}

export default CardMember
